import { useEffect, useState } from 'react';
import TaskTrackingService from '../../services/TaskTrackingService';

const EVENT = 'task-summary-changed';
const TTL_MS = 60 * 1000;
let cache = { at: 0, data: null, promise: null };

const load = (force) => {
    if (!localStorage.getItem('authToken')) {
        return Promise.resolve(null);
    }
    if (!force && cache.data && Date.now() - cache.at < TTL_MS) {
        return Promise.resolve(cache.data);
    }
    if (!cache.promise) {
        cache.promise = TaskTrackingService.summary()
            .then((data) => {
                cache = { at: Date.now(), data, promise: null };
                return data;
            })
            .catch(() => {
                // Task features stay hidden if the summary can't be loaded
                cache = { at: Date.now(), data: null, promise: null };
                return null;
            });
    }
    return cache.promise;
};

/** Call after any task change so the header badge and gating refresh. */
export const refreshTaskSummary = () => {
    cache.at = 0;
    window.dispatchEvent(new Event(EVENT));
};

/**
 * { openCount, participates, canManage, isAdmin, isTaskViewer, isAvTeam, avOnly } or null while
 * loading / when unavailable.
 */
const useTaskSummary = () => {
    const [summary, setSummary] = useState(cache.data);
    useEffect(() => {
        let alive = true;
        const refresh = (force) => load(force).then((d) => alive && setSummary(d));
        refresh(false);
        const onChange = () => refresh(true);
        window.addEventListener(EVENT, onChange);
        return () => {
            alive = false;
            window.removeEventListener(EVENT, onChange);
        };
    }, []);
    return summary;
};

/** Whether this user sees anything task related (Phase 4 gating). */
export const seesTasks = (summary) =>
    !!summary && (summary.canManage || summary.participates || summary.isTaskViewer || summary.isAvTeam);

export default useTaskSummary;
